<template>
    <div>
        <div>
            {{ address.name }}
        </div>
        <div>
            {{ address.organization_service }}
        </div>
        <div>
            {{ address.street }}
        </div>
        <div>
            {{ address.complement }}
        </div>
        <div>
            <template v-if="address.postal_box && address.postal_box.match(/^\d/)">
                BP
            </template>
            {{ address.postal_box }}
        </div>
        <div>
            {{ address.cedex || address.postal_code }}
            {{ address.city }}
            <template v-if="address.cedex">
                Cedex {{ address.cedex_number }}
            </template>
        </div>
        <div>
            {{ address.country }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            address: Object,
        },
    }
</script>
